import {
  Typography
} from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import { COLORS } from "../../../core/consts/redesign/commonRedesign";
import { Close, Info } from "../../../core/consts/redesign/icons";
import { default as AgentService, default as agentService } from "../../../core/services/AgentService";
import ButtonCustom from "../../../UIcomponentsRedesign/ButtonCustom/ButtonCustom";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import InputMain from "../../../UIcomponentsRedesign/InputMain/InputMain";
import { useStylesAddClientInnerModal } from "./useStylesAddClientInnerModal";

type propsType = {
  handleFinishClientAdding: () => void;
  isClientsPage?: boolean;
};

type ResponseDataType = {
  companyName: string;
  ceo: string;
  region: string;
  okved: string;
  clientIsRegister: boolean;
  clientIsAlreadyList: boolean;
  errorStatus: string;
};
const AddClientInnerModal: React.FC<propsType> = ({
  handleFinishClientAdding,
  isClientsPage = false
}) => {
  const classes = useStylesAddClientInnerModal();
  const [inputModalError, setInputModalError] = useState(false);
  const [notExistedClientInn, setNotExistedClientInn] = useState(false);
  const [valueModal, setValueModal] = useState("");
  const [clientData, setClientData] = useState<ResponseDataType>();
  const [isSent, setIsSent] = useState(false);

  const alertColor = clientData && clientData.clientIsRegister ? COLORS.warning : COLORS.alert;
  const noAlertBox = clientData !== null && clientData !== undefined &&
    !clientData.clientIsAlreadyList &&
    !clientData.clientIsRegister &&
    clientData.errorStatus === "";

  function determineAlertText(clientData: ResponseDataType) {
    if (!clientData) {
      return '';
    }
    if (clientData.clientIsAlreadyList) {
      return "Клиент есть в вашем списке";
    }
    if (clientData.clientIsRegister) {
      return "Клиент уже зарегистрирован";
    }
    if (clientData.errorStatus !== '') {
      return clientData.errorStatus;
    }
    return "";
  }

  const alertText = clientData ? determineAlertText(clientData) : "";

  useEffect(() => {
    if (valueModal.length === 10 || valueModal.length === 12) {
      !inputModalError &&
        valueModal.length > 0 &&
        AgentService.checkClientUlService({ Inn: valueModal.toString() })
          .then((res: ResponseDataType | "Ошибка") => {
            if (res === "Ошибка") {
              setNotExistedClientInn(true);
              setClientData(undefined);
            } else {
              setClientData(res);
              setNotExistedClientInn(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  }, [valueModal, inputModalError]);

  const handleModalSubmit = (event: any) => {
    event.preventDefault();
    setInputModalError(false);
    if (valueModal === "") setInputModalError(true);
  };

  const handleAddClient = () => {
    let Q = {
      inn: valueModal,
    };
    agentService
      .registerClientUlService(Q)
      .then((res) => {
        setIsSent(true);
        handleFinishClientAdding();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatInn = (value: string): string => {
    const digitsOnly = value.replace(/\D+/g, '');

    if (digitsOnly.length > 12) {
      return digitsOnly.slice(0, 12);
    }
    return digitsOnly;
  };

  const handleModalChange = (event: any) => {
    let formattedValue = event.target.value;
    formattedValue = formatInn(formattedValue);
    event.target.value = formattedValue;
    if (
      !event.target.value.match(/^([0-9]{10}|[0-9]{12})$/) ||
      event.target.value === ""
    ) {
      setInputModalError(true);
    } else {
      setInputModalError(false);
    }
    setValueModal(event.target.value);
  };

  return (
    <>
      {isSent ? (
        <>
          <div className={classes.box}>
            <h4 className={classes.title}>
              Клиент успешно добавлен
            </h4>
            <IconButtonMain
              color="noBgGray"
              style={{ padding: 0, height: '24px', width: '24px' }}
              buttonId="close-button"
              handleClickEvent={handleFinishClientAdding}
              icon={<Close color={COLORS.gray2} />}
            />
          </div>
          <Typography variant="body1" component="p">
            Теперь он будет отображаться в вашем списке клиентов
          </Typography>
          {!isClientsPage &&
            <ButtonCustom
              color="text_button__small"
              handleClick={() => handleFinishClientAdding()}
              style={{ width: '100%' }}
            >
              Вернуться к выбору клиента
            </ButtonCustom>}
        </>
      ) : (
        <>
          <div className={classes.box}>
            <h4 className={classes.title}>
              Добавление нового клиента
            </h4>
            <IconButtonMain
              color="noBgGray"
              style={{ padding: 0, height: '24px', width: '24px' }}
              buttonId="close-button"
              handleClickEvent={handleFinishClientAdding}
              icon={<Close color={COLORS.gray2} />}
            />
          </div>
          <Typography variant="body1" component="p">
            Введите ИНН клиента, которого вы хотите добавить
          </Typography>
          <form noValidate onSubmit={handleModalSubmit} style={{ width: "100%" }}>
            <InputMain
              value={valueModal}
              label={"ИНН клиента"}
              error={notExistedClientInn ? "Пожалуйста, проверьте ИНН" : ""}
              onChange={handleModalChange}
            />
          </form>
          {clientData && (
            <>
              <div className={classes.gridInfo}>
                {clientData.companyName && (
                  <div className={classes.gridInfoRow}>
                    <div className={classes.titleBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoTitle}
                      >
                        Наименование
                      </Typography>
                    </div>
                    <div className={classes.valueBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoValue}
                      >
                        {clientData.companyName}
                      </Typography>
                    </div>
                  </div>
                )}

                {clientData.ceo && (
                  <div className={classes.gridInfoRow}>
                    <div className={classes.titleBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoTitle}
                      >
                        Генеральный директор
                      </Typography>
                    </div>
                    <div className={classes.valueBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoValue}
                      >
                        {clientData.ceo}
                      </Typography>
                    </div>
                  </div>
                )}
                {clientData.region && clientData.region !== " " && (
                  <div className={classes.gridInfoRow}>
                    <div className={classes.titleBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoTitle}
                      >
                        Регион
                      </Typography>
                    </div>
                    <div className={classes.valueBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoValue}
                      >
                        {clientData.region}
                      </Typography>
                    </div>
                  </div>
                )}
                {clientData.okved && (
                  <div className={classes.gridInfoRow}>
                    <div className={classes.titleBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoTitle}
                      >
                        ОКВЭД
                      </Typography>
                    </div>
                    <div className={classes.valueBox}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={classes.gridInfoValue}
                      >
                        {clientData.okved}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
              {!noAlertBox ?
                <div className={classes.alertBox} style={{ backgroundColor: alertColor }}>
                  <div className={classes.infoIcon}><Info color={COLORS.white} /></div>
                  <span className={classes.alertText}>{alertText}</span>
                </div> : null}
            </>
          )}
          <div className={classes.buttonBox}>
            <ButtonCustom
              color="primary_w100"
              type="submit"
              disabled={
                !clientData ||
                (clientData && clientData.clientIsAlreadyList) ||
                (clientData && clientData.clientIsRegister) ||
                (clientData && !!clientData.errorStatus)
              }
              handleClick={handleAddClient}
              style={{ height: "64px" }}
            >
              Добавить клиента
            </ButtonCustom>
            {!isClientsPage &&
              <ButtonCustom
                color="text_button__small"
                handleClick={() => handleFinishClientAdding()}
                style={{ width: '100%' }}
              >
                Вернуться к выбору клиента
              </ButtonCustom>}
          </div>
        </>
      )}
    </>
  );
};

export default memo(AddClientInnerModal);
